/*
 *工具类
 */
import {
    Loading,
    Message
} from 'element-ui';
import $store from '@/store/index.js';
// import { delete } from 'vue/types/umd';

const formatTime = (date = new Date()) => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return {
        YMDhms: [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':'), //今天年月日时分秒
        lastMonth: (month - 1 <= 0 ? year - 1 : year) + '-' + formatNumber(month - 1 <= 0 ? 12 : month - 1) + '-01 00:00:00', //上月初
        beginMonth: year + '-' + month + '-01 00:00:00', //本月初
        earlyNextMonth: (month == 12 ? year + 1 : year) + '-' + formatNumber(month - 11 > 0 ? month - 11 : month + 1), //下月初
    }
}

const formatNumber = n => {
    n = n.toString();
    return n[1] ? n : '0' + n
}

//Loading
const loading = (v, i, r) => {
    const lo = Loading.service({
        lock: true,
        text: v || "加载中...",
        spinner: i || 'el-icon-loading',
        background: r || 'rgba(0, 0, 0, 0.7)'
    });
    return lo;
}

//Message
const message = (v, t, e) => {
    Message({
        message: v,
        type: ((!t && !e) ? "success" : ((t == 1 ? "success" : (t == 2 ? "warning" : (t == 3 ? "error" : ""))))),
        onClose: function() {
            e && e();
        }
    });
}

//判断数据类型
const getDataType = (v) => {
    let _result = Object.prototype.toString.call(v),
        _str = _result.replace("\[", "").replace("\]", "")
    return _str.split(' ')[1];
}

// const getDate = (v) => {
//     if (!v) return;
//     return new Date(v.replace(/-/g, "/"));
// };

//setSession
const sessionSet = (n, v) => {
    if (typeof v == 'object') {
        v = JSON.stringify(v);
    }
    window.sessionStorage.setItem(n, v);
}

//getSession
const sessionGet = (v) => {
        let get = window.sessionStorage.getItem(v);
        if (typeof JSON.parse(get) == 'object') {
            return JSON.parse(get);
        }
        return get;
    }
    //setCookie
const setCookie = (v) => {
    window.document.cookie = v.setName + "=" + v.setValue + ";path=/;expires=" + v.setDate;
}

const getCookie = (cname) => {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == '') c = c.substring(1);
        if (c.indexOf(name) != -1)
            return c.substring(name.length + 1, c.length);
    }
    return '';
}

/**
 * 将以base64的图片url数据转换为Blob
 * 用url方式表示的base64图片数据
 */
const convertBase64UrlToBlob = (urlData) => {
        var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
        //处理异常,将ascii码小于0的转换为大于0
        var ab = new ArrayBuffer(bytes.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < bytes.length; i++) {
            ia[i] = bytes.charCodeAt(i);
        }
        return new Blob([ab], {
            type: 'image/png'
        });
    }
    // 将base64转换成file对象
const dataURLtoFile = (dataurl, filename = 'file') => {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let suffix = mime.split('/')[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
    })
}

//字体编号排序Y轴
const fontsY = ({
    data = [],
    success
} = {}) => {
    if (data.length == 1) {
        return success && success(data);
    }
    //Y轴顶部字体降序
    data.sort((a, b) => {
        //计算保存中心点
        a['centralPoint'] = {
            x: a.x + a.width * .5,
            y: a.y + a.height * .5
        };
        b['centralPoint'] = {
            x: b.x + a.width * .5,
            y: b.y + b.height * .5
        };
        return a.y - b.y;
    });

    //中心点Y轴上下10范围内合并数组
    let lists = [];
    data.forEach(item => {
            if (item.centralPoint) {
                let items = data.filter(n => {
                    /**
                     * 计算规则
                     * 已一个字体为参考，在基准字体的上下边范围内
                     * 或其它计算字体的中心点对比参考字体的上边下边有一个相差5范围内
                     */
                    if (n.centralPoint && (n.centralPoint.y >= item.y && n.centralPoint.y <= item.y + item.height || Math.abs(n.centralPoint.y - item.y) <= 5 || Math.abs(n.centralPoint.y - (item.y + item.height)) <= 5)) {
                        delete n.centralPoint;
                        return true;
                    }
                    return false;
                });

                if (items && items.length > 0) {
                    //将同组按X轴从左往右排列
                    items.sort((a, b) => {
                        return a.x - b.x;
                    })
                    lists = [...lists, ...items];
                }
            }
        })
        //去重
    lists = [...new Set(lists)];

    success && success(lists || []);
}

//数组根据某标识获取某数据array：对象数组；sign：查找依据标识对象，{id: 6}，[1,2,3]；getField：想获取的数据传字符串格式，不传默认获取数组内对应的整个数据
const getArrayData = (array, sign, getField) => {
    if (typeof sign == 'object' && Object.keys(sign).length > 0) {
        let [_key, ] = Object.keys(sign),
            _value = sign[_key],
            _fields = [];
        for (let _i = 0; _i < array.length; _i++) {
            let _n = array[_i];
            if (getDataType(_value) === 'Array') {
                _value.forEach(c => {
                    if (c == _n[_key]) {
                        _fields.push(_n[getField]);
                    }
                })
            } else if (getDataType(_value) === 'Object') {
                Object.keys(_value).forEach(c => {
                    if (c == _n[_key]) {
                        _fields.push(_n[getField]);
                    }
                })
            } else if (_value == _n[_key]) {
                return _n[getField];
            }
        }
        if (getDataType(_value) === 'Array' || getDataType(_value) === 'Object') {
            return _fields;
        }
    }
}

//计算画布显示铺满并完整比例，按最小边起算
//img: 图片信息；container：容器信息
const fullScreenRatio = ({
    img,
    container,
    edge,
    success
  } = {}) => {
    var screenRatio = 1
    if (container.width > container.height) {
      screenRatio = (container.height - edge) / img.height
      const imgWidth = img.width * screenRatio
      if (imgWidth > container.width) {
        screenRatio *= (container.width - edge) / imgWidth
      }
    } else {
      screenRatio = (container.width - edge) / img.width
      const imgHeight = img.height * screenRatio
      if (imgHeight > container.height) {
        screenRatio *= (container.height - edge) / imgHeight
      }
    }

    success && success(screenRatio)
  }

//计算画布图片上下左右居中的偏移量
const canvasDrawImageOffset = ({
    container,
    img,
    success
} = {}) => {
    var centre_x = container.width * 0.5,
        centre_y = container.height * 0.5,
        imgCentre_x = img.width * 0.5,
        imgCentre_y = img.height * 0.5;

    success && success({
        x: centre_x - imgCentre_x,
        y: centre_y - imgCentre_y
    });
}

//画布绘制
// 画布绘制
const setCanvas = ({
    canvas,
    list = [],
    rectRatio = 1,
    imgUrl,
    container,
    selected = new Map(),
    erases = [],
    exports = false,
    success,
    onclick,
    onExport,
    testBox = {},
    showSize = true, //默认显示宽高
    option = {
      sequenceColor: '#444',
      sequenceSize: '14px Calibri',
      sizeColor: '#444',
      whSize: '16px Calibri',
      borderColor: '#0707de',
      selectColor: 'red', // 选中颜色
      edge: 20, //画布内容边距单位px
    },
    coverage = false // 能否对单个字体进行覆盖操作 - 一般用于个别需要单独覆盖的操作
  } = {}) => {
    var ctx = canvas.getContext('2d')
    var img = new Image()

    if (!canvas.getContext) return

    // 尺寸改变
    if (container) {
      canvas.width = container.clientWidth
      canvas.height = container.clientHeight
    }

    // 解决图片跨域问题
    img.setAttribute('crossOrigin', 'Anonymous')

    img.onload = function(e) {
      if (!container) {
        canvas.width = img.width
        canvas.height = img.height
      }
      // 填充区域
      if (erases && erases.length > 0) {
        ctx.drawImage(img, 0, 0, img.width, img.height)
        erases.forEach(item => {
          ctx.fillStyle = 'white'
          ctx.fillRect(item.x / rectRatio, item.y / rectRatio, item.width / rectRatio, item.height / rectRatio)
        })
      } else {
        // 计算图片比例
        fullScreenRatio({
          container: canvas,
          img,
          edge: option.edge || 0,
          success(ratio) {
            img.width *= ratio
            img.height *= ratio
            // 计算比例后图片偏移量
            canvasDrawImageOffset({
              container: canvas,
              img,
              success(res) {
                const excursion = res
                ctx.drawImage(img, res.x, res.y, img.width, img.height)
                if (JSON.stringify(testBox) !== '{}') {
                  // 测试虚线框位置
                  ctx.fillStyle = 'red'
                  ctx.rect(testBox.x1, testBox.y1, testBox.x2 - testBox.x1, testBox.y2 - testBox.y1)
                  ctx.stroke()
                }
                // 字体边框
                if (list && list.length > 0) {
                  list.forEach((item, index) => {
                    ctx.font = option.sequenceSize
                    ctx.fillStyle = '#CC0000'
                    ctx.strokeStyle = option.borderColor
                    ctx.globalAlpha = 1
                    const _origin_x = item.x1 / rectRatio * ratio + excursion.x
                    const _origin_y = item.y1 / rectRatio * ratio + excursion.y
                    const _origin_w = (item.x2 - item.x1) / rectRatio * ratio
                    const _origin_h = (item.y2 - item.y1) / rectRatio * ratio

                    // // 产品颜色
                    // if (item.color && item.productTypeId) {
                    //   ctx.strokeStyle = item.color
                    // }
                    // 自定义指定颜色
                    if (item.specificColor) {
                      ctx.strokeStyle = item.specificColor
                    }
                    // 选中
                    if (selected.has(item.key) || item.selected) {
                      ctx.strokeStyle = option.selectColor
                    }
                    // 是否绘制白色覆盖层（用于消除字体内容，有颜色背景图会有白块显示）
                    if (coverage && item.coverage) {
                      ctx.fillStyle = 'white'
                      // 将覆盖面积大一点，因计算后的比例有概率会覆盖不完全
                      ctx.fillRect(_origin_x - 1, _origin_y - 1, _origin_w + 2, _origin_h + 2)
                      // 不绘制宽高及边框 forEach的return跟continue作用相同
                      return
                    }
                    // 将字体坐标位置定于左上角，竖线右边，横线上边
                    ctx.textAlign = 'left'
                    ctx.textBaseline = 'bottom'

                    //绘制编号及边框
                    let valuaRule = {
                      1: '标',
                      2: '中',
                      3: '英',
                      4: '字',
                      5: '条'
                    }[item.valuaRule];
                    ctx.fillText(`${index + 1}${item.groupNo ? '-' + item.groupNo : ''}${valuaRule || ''}`, _origin_x, _origin_y)
                    ctx.strokeRect(_origin_x, _origin_y, _origin_w, _origin_h)
                    /**
                     * 功能待定
                     * 后台暂不支持
                     * 20210518
                     */
                    // //绘制字体类型
                    // let type_x = (item.x1 + String(index + 1).length * 16) / rectRatio * ratio + excursion.x
                    // ctx.font = '12px Calibri'
                    // //字体类型对应绘制颜色
                    // ctx.fillStyle = '#000'
                    // ctx.fillText('中', type_x, _origin_y)

                    // 绘制字体宽高
                    if (showSize && (item.height || item.high || item.width)) {
                      ctx.font = option.whSize
                      ctx.fillStyle = '#CC0000'
                      // 根据竖线文字左右居中
                      if (item.height || item.high) {
                        ctx.textAlign = 'center'
                        ctx.fillText(Math.round((item.height || item.high) / rectRatio), _origin_x, _origin_y + _origin_h * 0.5)
                      }
                      // 根据横线文字上下居中
                      if (item.width) {
                        ctx.textBaseline = 'middle'
                        ctx.fillText(Math.round(item.width / rectRatio), _origin_x + _origin_w * 0.5, _origin_y)
                      }
                    }
                  })
                }

                // 排序完成后返回数据
                success && success({
                  ratio,
                  excursion,
                  ctx
                })

                // 点击返回选中字体
                canvas.onclick = function(e) {
                  const _data = list.filter((item, index) => {
                    item['index'] = index
                    const _x2 = item.x2 / rectRatio * ratio + excursion.x > e.offsetX
                    const _x1 = item.x1 / rectRatio * ratio + excursion.x < e.offsetX
                    const _y2 = item.y2 / rectRatio * ratio + excursion.y > e.offsetY
                    const _y1 = item.y1 / rectRatio * ratio + excursion.y < e.offsetY

                    return _x2 && _x1 && _y2 && _y1
                  })
                  onclick && onclick(_data)
                }
              }
            })
          }
        })
      }
    }
    img.src = imgUrl

    // 导出图片
    if (exports) {
      setTimeout(_ => {
        const base64 = canvas.toDataURL('image/png', 1)
        const imgFile = blobToFile(base64, new Date().valueOf())
        onExport && onExport({
          base64,
          imgFile
        })
      }, 300)
    }
  }

//画布字体根据比例计算高度
//计算字体宽高index: 已哪个下标的字体为基准计算
const setFontWH = ({
    data,
    proportion,
    height,
    success
} = {}) => {
    if (!data || data.length <= 0) return;

    const fontRatio = height / proportion;
    data.forEach((item, i) => {
        console.log(Math.round((item.x2 - item.x1) * fontRatio) || 1);
        item.inputHeight = height;
        item.imgHeight = fontRatio;
        item.width = Math.round((item.x2 - item.x1) * fontRatio) || 1;
        item.height = Math.round((item.y2 - item.y1) * fontRatio) || 1;
        item.high = Math.round((item.y2 - item.y1) * fontRatio) || 1;
        item['selected'] = false;
    });

    success && success(data);
}

//下载文件
const downloadForName = (url, filename) => {
    getBlob(url, function(blob) {
        saveAs(blob, filename);
    });
}

const getBlob = (url, cb) => {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function() {
        if (xhr.status === 200) {
            cb(xhr.response);
        }
    };
    xhr.send();
}

const saveAs = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
    } else {
        var link = document.createElement('a');
        var body = document.querySelector('body');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.style.display = 'none';
        body.appendChild(link);
        link.click();
        body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
    }
}

//将base64转换为file文件（兼容IE11）
const blobToFile = (dataurl, filename = 'file') => {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n),
        suffix = mime.split('/')[1]
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    let theBlob = new Blob([u8arr], {
        type: mime
    });
    theBlob.lastModifiedDate = new Date($store.state.newData);
    theBlob.name = `${filename}.${suffix}`;
    return {
        file: theBlob,
        name: `${filename}.${suffix}`
    };
}

//根据坐标截取canvas并生成file格式
const getCanvasCutImg = (nodeId, x1, y1, w, h, index) => {
    var canvas = document.createElement('canvas'),
        cxt = canvas.getContext("2d"),
        mainCxt = nodeId.getContext("2d"),
        dataImg = mainCxt.getImageData(x1, y1, w, h);

    canvas.width = w;
    canvas.height = h;
    cxt.putImageData(dataImg, 0, 0, 0, 0, w, h);
    let base64 = canvas.toDataURL("image/png"),
        imgFile = blobToFile(base64, index + 1);

    return imgFile;
}

/**
 * 列表点击返回起始/结束点击位置
 * 开始结束大小排序
 * 点击相同去除标识
 */
const listSignSE = ({ list = [], start = -1, end = -1, index = 0, success } = {}) => {
    let s = start,
        e = end,
        i = index,
        ids = [],
        indexs = [],
        isLongArr = [], //长条内容集合
        samePriceCE = false;

    if (e < 0) {
        //结束位
        e = s == i || s < 0 ? -1 : i;
        //起始位
        s = s < 0 ? i : (s == i ? -1 : s);
    }
    if (e >= 0) {
        //存在区间
        //计算开始结束排序
        if (s > e) {
            const _s = JSON.parse(JSON.stringify(s)),
                _e = JSON.parse(JSON.stringify(e));
            s = _e;
            e = _s;
        }
        console.log(list)
        if (list && list.length > 0) {
            for (let j = s; j <= e; j++) {
                list[j].id.forEach(m => {
                    ids.push(m);
                })
                indexs.push(j);

                if (list[j].valueLong == 1) { //中英文同价（字体内容的  ite.valueLong == 1）
                    samePriceCE = true
                }
                if (list[j].valueLong == 3) { //中英文不同价（字体内容的 ite.valueLong == 3）
                    samePriceCE = false
                }
                isLongArr.push(list[j].isLong)

            }
        }
    }

    success && success({
        start: s,
        end: e,
        ids,
        indexs,
        samePriceCE,
        isLongArr
    });
}


//获取是否会员过期
// import * as indexAPI from "./index";

// const isLate = upload => {
//     return new Promise((resolve, reject) => {
//         indexAPI.isOverTime({}).then(res => {
//             if (res.code === 0) {
//                 upload && upload.$refs['upload-inner'] && upload.$refs['upload-inner'].handleClick();
//                 return resolve();
//             } else {
//                 return reject();
//             }
//         }).catch(err => {
//             let acountInfo = JSON.parse(sessionStorage.getItem('acountInfo'));
//             if (acountInfo.childrenIs !== -1) {
//                 acountInfo.childrenIs = -1;
//                 sessionStorage.setItem('acountInfo', JSON.stringify(acountInfo));
//             }
//             Message.closeAll();
//             return reject(err);
//         });
//     });
// }

export default {
    formatTime,
    loading,
    message,
    getDataType,
    sessionSet,
    sessionGet,
    setCookie,
    getCookie,
    convertBase64UrlToBlob,
    dataURLtoFile,
    getArrayData,
    setCanvas,
    setFontWH,
    downloadForName,
    getCanvasCutImg,
    blobToFile,
    fontsY,
    canvasDrawImageOffset,
    fullScreenRatio,
    listSignSE,
    // isLate
}


// WEBPACK FOOTER //
// ./src/api/utilsT.js